// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyA6mPWvqEVwtvZUJtsbZnu8GbKPrvf8C14",
    authDomain: "lernvent.firebaseapp.com",
    databaseURL: "https://lernvent-default-rtdb.firebaseio.com",
    projectId: "lernvent",
    storageBucket: "lernvent.firebasestorage.app",
    messagingSenderId: "161404186165",
    appId: "1:161404186165:web:81c07e1ea6bc24e16f8b7c",
    measurementId: "G-70T33M2DMG"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);